import { render, staticRenderFns } from "./StampModal.vue?vue&type=template&id=338b16ec&"
import script from "./StampModal.vue?vue&type=script&lang=ts&"
export * from "./StampModal.vue?vue&type=script&lang=ts&"
import style0 from "./StampModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports